import { Component, inject, OnInit, afterNextRender } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private router = inject(Router);
  private seoService = inject(SeoService);

  constructor() {
    afterNextRender(() => {
      document.documentElement.classList.remove('pre-hydration');
    });
  }

  ngOnInit(): void {
    // Fire immediately for SSR and the initial client load
    this.seoService.updateForRoute(this.router.url);

    // Re-fire on every subsequent navigation
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.seoService.updateForRoute(e.urlAfterRedirects));
  }
}
